
import { CheckCircle } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";

const CutThroughHype = () => {
  return (
    <section className="py-20 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] z-0"></div>
      <div className="container mx-auto px-6 relative z-10">
        <AnimatedCard animation="fade-in" className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Cut Through the AI Hype and Get to <span className="text-primary">Real Results</span>
          </h2>
        </AnimatedCard>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <AnimatedCard animation="slide-in-left">
            <div className="space-y-6">
              <p className="text-lg text-gray-300">
                The AI learning curve is steep. The vendor noise is worse. We simplify the process 
                with education that's relevant and clear — then help your firm move into smart, 
                phased adoption. Our approach is flexible, fast, and always tailored to your firm's goals.
              </p>
            </div>
          </AnimatedCard>
          
          <AnimatedCard animation="slide-in-right" delay={200}>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Self-paced AI learning modules</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Live workshops for legal teams</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">AI strategy blueprints</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="mt-1 bg-primary/20 p-2 rounded mr-3">
                  <CheckCircle className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-medium">Advisory to guide adoption, step by step</p>
                </div>
              </li>
            </ul>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default CutThroughHype;
